/**
 * Form Configuration
 * Centralized configuration for form defaults, validation, and options
 */

import { getDate } from '../helpers/dates';

export const FORM_CONFIG = {
  // Default form values
  DEFAULTS: {
    // Audio form defaults
    AUDIO_FORM: {
      trackRating: 1,
      mp3Files: [],
      wavFiles: [],
      trackName: '',
      album: null,
      tags: [],
      jobTitle: '',
      producer: '',
      agency: '',
      client: '',
      creativedirector: [],
      dateCompleted: getDate(),
      dateExpires: getDate(),
      flightingPlatform: [],
      flightingCodes: [],
      sessionArtists: [],
      composers: [],
      genre: null,
      key: null,
      studios: [],
      isrc: '',
      iswc: '',
      writers: '',
      publisher: null,
      prs: '',
      recordLabel: null,
      master: '',
      copyrightOwner: '',
      copyrightYear: '',
      description: '',
      artist: null,
      flightingCode: '',
      assignedUid: '',
      bpm: null,
      duration: '',
      trackType: 'Full Track',
      isLicensed: false,
      licenseStatus: '',
    },
    
    // Filter form defaults
    FILTER_FORM: {
      searchValue: '',
      selectedPlaylist: null,
      orderBy: { column: 'dateCompleted', direction: 'desc' },
      date: {
        enabled: false,
        range: false,
        to: Date.now(),
        from: 439689600000, // December 8, 1983
      },
    },
  },

  // Validation rules
  VALIDATION: {
    // Field length limits
    FIELD_LENGTHS: {
      TRACK_NAME: { min: 1, max: 100 },
      DESCRIPTION: { min: 0, max: 500 },
      BPM: { min: 1, max: 300 },
      COPYRIGHT_YEAR: { min: 1900, max: new Date().getFullYear() + 10 },
    },
    
    // Required fields
    REQUIRED_FIELDS: [
      'trackName',
      'dateCompleted',
    ],
    
    // Field patterns
    PATTERNS: {
      BPM: /^\d{1,3}$/,
      YEAR: /^\d{4}$/,
      EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    },
  },

  // Form field options
  OPTIONS: {
    // Rating options
    RATINGS: [1, 2, 3, 4, 5],
    
    // License status options
    LICENSE_STATUS: [
      'Licensed',
      'Unlicensed',
      'Pending',
      'Expired',
      'Renewed',
    ],
    
    // Track types (imported from file config)
    TRACK_TYPES: [
      'Full Track',
      'Instrumental',
      'Variation',
      'Alt Version',
      'Edited Version',
      'Extended Version',
      'Remix',
      'Cover Version',
      'Live Version',
      'Acoustic Version',
      'Radio Edit',
      'Clean Version',
      'Explicit Version',
    ],
    
    // Duration format options
    DURATION_FORMATS: [
      'MM:SS',
      'HH:MM:SS',
      'Seconds',
    ],
  },

  // Input constraints
  CONSTRAINTS: {
    // Text input limits
    MAX_TAG_LENGTH: 50,
    MAX_TAGS: 20,
    MAX_SESSION_ARTISTS: 10,
    MAX_COMPOSERS: 10,
    MAX_CREATIVE_DIRECTORS: 5,
    
    // Numeric limits
    MIN_BPM: 40,
    MAX_BPM: 200,
    MIN_RATING: 1,
    MAX_RATING: 5,
  },

  // Form behavior settings
  BEHAVIOR: {
    // Auto-save settings
    AUTO_SAVE: {
      ENABLED: false,
      INTERVAL: 30000, // 30 seconds
    },
    
    // Validation timing
    VALIDATION_DELAY: 500, // ms after user stops typing
    
    // Form submission
    SUBMIT_TIMEOUT: 30000, // 30 seconds
    
    // Progress indication
    SHOW_PROGRESS: true,
  },

  // Error messages
  ERRORS: {
    REQUIRED_FIELD: 'This field is required',
    INVALID_FORMAT: 'Invalid format',
    TOO_LONG: 'Text is too long',
    TOO_SHORT: 'Text is too short',
    INVALID_NUMBER: 'Please enter a valid number',
    INVALID_DATE: 'Please enter a valid date',
    SAVE_FAILED: 'Failed to save form data',
    LOAD_FAILED: 'Failed to load form data',
  },
};

export default FORM_CONFIG;